import React from "react";
import UiInput from "../../../_uiComponents/UiInput";
import { UiButton } from "../../../../_uiComponents/common/form/UiButton";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";

export default function ForgetPassword(props) {
     return (
          <>
               <Box component="div" sx={{ width: "100%" }}>
                    <div className="sba-auth-top-heading">
                         <h5>Please enter your registered email address</h5>
                    </div>
                    <UiInput type="text" label="Enter Email" />
                    <Grid container sx={{ mb: 13 }}>
                         <Grid item xs sx={{ textAlign: "right" }}>
                              <UiButton
                                   name="Next"
                                   variant="contained"
                                   size="medium"
                              />
                         </Grid>
                    </Grid>
                    <p className="sba-login-bottom-support-mail">
                         Please reach <span>support@sherbetrewards.com </span>
                         for further queries
                    </p>
               </Box>
          </>
     );
}
